import ActivityInformationBarChart from './ActivityInformationBarChart'

export default ActivityInformationBarChart
